import * as Settings from '@/config/settings.js';

export default{
    methods:{
        getProgramSystem(){
            return Settings.systemProgramId;
        },
        isSalvadorProgram(){
            return ([1,3].includes(Settings.systemProgramId) == true);
        },
        isHondurasProgram(){
            return ([2,4].includes(Settings.systemProgramId) == true);
        }
    }
}
